'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require('react-transition-group');

require('./notification.scss');

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _iconButton = require('../icon-button/icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _title = require('../title/title');

var _title2 = _interopRequireDefault(_title);

var _text = require('../text/text');

var _text2 = _interopRequireDefault(_text);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'information',
  instruction: 'information',
  hint: 'information'
};

function Notification(_ref) {
  var className = _ref.className,
      message = _ref.message,
      title = _ref.title,
      type = _ref.type,
      onClose = _ref.onClose,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'message', 'title', 'type', 'onClose', 'children']);

  var classes = (0, _classnames2.default)('notification', type && 'notification--' + type, className);
  var attributes = {
    style: props.style ? props.style : undefined
  };

  // TODO: REMOVE hide-on-mobile, hide-on-desktop

  return _react2.default.createElement(
    _reactTransitionGroup.CSSTransition,
    _extends({
      classNames: 'notification--animation',
      'in': true,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        enter: 1,
        exit: 500
      }
    }, props),
    _react2.default.createElement(
      'div',
      _extends({ className: classes }, attributes),
      _react2.default.createElement(
        'div',
        { className: 'notification__icon' },
        _react2.default.createElement(_icon2.default, { name: icons[type], size: '20', className: 'hide-on-mobile' }),
        _react2.default.createElement(_icon2.default, { name: icons[type], size: '15', className: 'hide-on-desktop' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'notification__content' },
        _react2.default.createElement(
          _title2.default,
          { level: '6', color: 'darker', density: 'none', className: 'notification__title' },
          title
        ),
        message && _react2.default.createElement(
          _text2.default,
          { size: 'small', color: 'dark' },
          message
        ),
        children
      ),
      _react2.default.createElement(
        'div',
        { className: 'notification__close-icon' },
        onClose && _react2.default.createElement(_iconButton2.default, { icon: 'cross', size: 'small', shape: 'circle', onClick: onClose })
      )
    )
  );
}

Notification.propTypes = {
  className: _propTypes2.default.string,
  message: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  type: _propTypes2.default.oneOf(['success', 'error', 'warning', 'instruction', 'info', 'hint']),
  title: _propTypes2.default.string,
  onClose: _propTypes2.default.func
};

exports.default = Notification;